/**
 * Created by AlexanderC on 3/7/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FsDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let FsDriver = exports.FsDriver = function (_AbstractDriver) {
  _inherits(FsDriver, _AbstractDriver);

  /**
   * @param {String} file
   */
  function FsDriver() {
    let file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, FsDriver);

    var _this = _possibleConstructorReturn(this, (FsDriver.__proto__ || Object.getPrototypeOf(FsDriver)).call(this));

    _this._fs = _fs2.default;
    _this._file = file;
    return _this;
  }

  /**
   * @returns {String}
   */


  _createClass(FsDriver, [{
    key: 'setFs',


    /**
     * @param {fs|s3fs|*} fs
     * @returns {FsDriver}
     */
    value: function setFs(fs) {
      this._fs = fs;

      return this;
    }

    /**
     * @param {String} file
     * @returns {FsDriver}
     */

  }, {
    key: 'setFile',
    value: function setFile(file) {
      this._file = file;

      return this;
    }

    /**
     * @param {String} file
     * @private
     */

  }, {
    key: '_load',
    value: function _load() {
      let file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this._file = file || this._file;

      this._fs.readFile(this._file, (error, data) => {
        let configStr = data ? data.toString() : '{}';

        if (error && error.name !== 'NoSuchKey') {
          this.fail(`Error reading configuration file '${this._file}': ${error}`);

          return;
        }

        this.loadedJson(configStr);
      });
    }
  }, {
    key: 'file',
    get: function get() {
      return this._file;
    }

    /**
     * @returns {fs|s3fs|*}
     */

  }, {
    key: 'fs',
    get: function get() {
      return this._fs;
    }
  }]);

  return FsDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Config/Driver/FsDriver.js
// module id = 172
// module chunks = 0